import React from 'react';
import PageLayout from "../layouts/page_layout";
import CalendarContent from "../components/page_content/calendar_content";
import Breadcrumb from "../components/breadcrumb";
export default function CalendarPage() {
  return (
   <PageLayout>
    <Breadcrumb title="Calendar"/>
    <CalendarContent/>
   </PageLayout>
  );
}
